import { useContext } from 'react'

import { RequestProfileTabEmailsSummaryExpandContext } from '../../RequestProfileTabEmails.contexts'

export function useRequestProfileTabEmailsSummaryExpandContext() {
  return useContext(RequestProfileTabEmailsSummaryExpandContext)
}
